import styled from "styled-components";

export const Container = styled.div`
  /* background: url(${(props) => props.bg}) no-repeat left top; */
  background-size: contain;
  padding: 20px;
  text-align: center;
  width: 313px;
  margin-right: 20px;
  margin-bottom: 20px;
  font-family: Roboto;
  border:1px solid #000;

  strong a {
      text-decoration:none;
      color:#000;
      font-weight:bold;
      font-size: 16px;
  }
`;
export const ImgFooter = styled.img`
  height: 40px;
`;
export const ImgHeader = styled.img`
  height: 60px;
`;
export const ImgWifi = styled.img`
  width: 30px;
  padding-bottom: 5px;
  margin-top: 5px;
`;
export const ButtonPrint = styled.button`
  background: #ed4e2a;
  padding: 10px 30px 10px 20px;
  border-radius: 40px;
  color: #fff;
  box-shadow: 1px 1px 7px 3px #ccc;
  border: none;
  font-weight: bold;
  font-size: 16px;
`;
